import { render, staticRenderFns } from "./passing-train-list.vue?vue&type=template&id=8c25f23c&scoped=true"
import script from "./passing-train-list.vue?vue&type=script&lang=js"
export * from "./passing-train-list.vue?vue&type=script&lang=js"
import style0 from "./passing-train-list.vue?vue&type=style&index=0&id=8c25f23c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c25f23c",
  null
  
)

export default component.exports